import React from 'react';
import { ArrowLeftIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FontComparisonPage() {
  return <div className="min-h-screen bg-[#f8f8f8] text-[#111111] pb-24" data-id="element-1483">
      {/* Load fonts locally */}
      <style data-id="element-1484">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');
          
          .font-atkinson {
            font-family: 'Atkinson Hyperlegible', sans-serif;
          }
          
          .font-ibm {
            font-family: 'IBM Plex Sans', sans-serif;
          }
        `}
      </style>

      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-1485">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1486">
          <Link to="/home" className="flex items-center text-gray-500 hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-1487">
            <ArrowLeftIcon size={18} className="mr-2" data-id="element-1488" />
            Back to Home
          </Link>
          <div className="font-semibold text-[#1a0647]" data-id="element-1489">
            Font Evaluation Tool
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-12" data-id="element-1490">
        <div className="mb-12 text-center" data-id="element-1491">
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-1492">
            In-App Typography Comparison
          </h1>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-1493">
            Comparing Atkinson Hyperlegible vs IBM Plex Sans for the Caveo
            guided walkthrough experience.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1494">
          {/* ATKINSON COLUMN */}
          <div className="space-y-8" data-id="element-1495">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1496">
              Atkinson Hyperlegible
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1497">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1498">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1499">
                <div data-id="element-1500">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1501">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1502">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1503">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1504">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1505">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1506">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1507">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1508">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1509">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1510">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1511">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1512">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1513">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1514">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1515">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1516">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1517">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1518">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1519">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1520">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1521">
                  <span className="text-sm font-bold text-gray-500" data-id="element-1522">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-bold text-[#631bb7]" data-id="element-1523">Skip</span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1524">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1525"></div>
                </div>
                <div className="p-6" data-id="element-1526">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1527">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1528">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1529">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1530">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1531">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1532"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1533">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1534">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1535"></div>
                      <span className="font-medium text-gray-700" data-id="element-1536">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-bold text-base hover:bg-[#521099] transition-colors" data-id="element-1537">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1538">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1539">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1540">
                <div className="flex items-center justify-between" data-id="element-1541">
                  <span className="text-lg font-normal" data-id="element-1542">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1543">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1544">
                  <span className="text-lg font-bold" data-id="element-1545">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1546">
                    The quick brown fox
                  </span>
                </div>
                <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800 font-sans" data-id="element-1547">
                  Note: Atkinson Hyperlegible only comes in Regular and Bold
                  weights natively.
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1548">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1549">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1550">
                <div className="flex flex-wrap gap-4" data-id="element-1551">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-bold" data-id="element-1552">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-bold" data-id="element-1553">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1554">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide flex items-center" data-id="element-1555">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1556" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1557">
                    Required
                  </span>
                </div>
                <div data-id="element-1558">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1559">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1560" />
                </div>
              </div>
            </div>
          </div>

          {/* IBM PLEX SANS COLUMN */}
          <div className="space-y-8" data-id="element-1561">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1562">
              IBM Plex Sans
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1563">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1564">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1565">
                <div data-id="element-1566">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1567">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1568">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1569">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1570">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1571">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1572">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1573">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1574">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1575">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1576">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1577">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1578">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1579">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1580">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1581">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1582">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1583">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1584">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1585">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1586">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1587">
                  <span className="text-sm font-semibold text-gray-500" data-id="element-1588">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-semibold text-[#631bb7]" data-id="element-1589">
                    Skip
                  </span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1590">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1591"></div>
                </div>
                <div className="p-6" data-id="element-1592">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1593">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1594">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1595">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1596">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1597">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1598"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1599">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1600">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1601"></div>
                      <span className="font-medium text-gray-700" data-id="element-1602">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-semibold text-base hover:bg-[#521099] transition-colors" data-id="element-1603">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1604">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1605">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1606">
                <div className="flex items-center justify-between" data-id="element-1607">
                  <span className="text-lg font-normal" data-id="element-1608">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1609">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1610">
                  <span className="text-lg font-medium" data-id="element-1611">Medium (500)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1612">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1613">
                  <span className="text-lg font-semibold" data-id="element-1614">SemiBold (600)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1615">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1616">
                  <span className="text-lg font-bold" data-id="element-1617">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1618">
                    The quick brown fox
                  </span>
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1619">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1620">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1621">
                <div className="flex flex-wrap gap-4" data-id="element-1622">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-semibold" data-id="element-1623">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-semibold" data-id="element-1624">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1625">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide flex items-center" data-id="element-1626">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1627" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide" data-id="element-1628">
                    Required
                  </span>
                </div>
                <div data-id="element-1629">
                  <label className="block text-sm font-semibold text-gray-700 mb-1" data-id="element-1630">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1631" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}